














































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {Sistema} from '@/model/resource/Sistema'
import {SistemaCollection} from '@/model/collection/SistemaCollection'
import {ListSistemaSchema} from '@/schema/resource/Sistema/ListSistemaSchema'
import {CsvSistemaSchema} from '@/schema/resource/Sistema/CsvSistemaSchema'

@Component
export default class ListSistemaView extends Mixins(MixinQueryRouter) {
  schema = new ListSistemaSchema()
  collection = new SistemaCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: Sistema) {
    Helper.pushByName('editSistema', item.$id)
  }

  async removeItem(item: Sistema) {
    await new DialogRemove(item).confirm(() => item.removeSistema())
    await this.collection.listSistema()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new SistemaCollection().clearFilters().addFilter(params)

    await csv.listCsvSistema()
    new CsvSistemaSchema().downloadCsv(csv.all())
  }
}
